import { Injectable, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { LaunchStepProvider } from '../launch-step-provider';

@Injectable({
  providedIn: 'root'
})
export class LaunchStepManagerService implements OnDestroy {
  private _isExecuting: boolean = false;

  readonly destroyed$ = new Subject<boolean>();
  readonly launchStepProviders: Array<LaunchStepProvider> = [];

  constructor() {
    this.launchStepProviders.forEach(async launchStepProvider => {
      launchStepProvider
        .onStepReady()
        .pipe(takeUntil(this.destroyed$))
        .subscribe(async () => {
          if (await this.areAllStepsReady()) {
            this.executeOnboardingSteps().then(() => {});
          }
        });
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  private async areAllStepsReady(): Promise<boolean> {
    for (const launchStepProvider of this.launchStepProviders) {
      if (!(await launchStepProvider.isStepReady())) {
        return false;
      }
    }

    return true;
  }

  private async executeOnboardingSteps() {
    if (this._isExecuting) {
      return;
    }

    this._isExecuting = true;

    for (const launchStepProvider of this.launchStepProviders) {
      if (await launchStepProvider.isStepRequired()) {
        try {
          await launchStepProvider.executeStep();
        } catch (err) {
          // TODO: Future state consider error handling
        }
      }
    }

    this._isExecuting = false;
  }
}
